// extracted by mini-css-extract-plugin
export var baseButton = "_qa-0";
export var controlsArrowKeys = "_qa-1";
export var controlsResetButton = "_qa-2";
export var lightGameButton = "_qa-4 _qa-0";
export var playAgainButton = "_qa-5 _qa-0";
export var startGameButton = "_qa-3 _qa-0";